























































































































import Vue from "vue";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  ACTIVATE_PUBLISHED_JOB,
  JOB_GENERATION_FROM_PROMPT,
  JOB_GENERATION_MATCHING_CANDIDATES,
  JOB_GENERATION_PROMPT_RESPONSE,
  JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
  POST_JOB,
  JOB_SHORT_URL,
  CREATE_SCREENING_QUESTION,
  CANDIDATE_DATA
} from "@/store/modules/recruiter/constants";
import { SEND_EMAIL } from "@/store/modules/common/constants";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import { EmailTypes, JobDataTypes } from "@/interfaces/app.interface";
import { get_search_candidates } from "@/store/apis/recruiter";
import AppOverlayLoader from "@/components/shared/AppOverlayLoader.vue";
import {
  CreateScreeningQuestionsPayload,
  ScreeningQuestionPayload,
  ScreeningQuestionsResponse
} from "@/store/modules/recruiter/interfaces";
import { APP_ASSESSMENTS } from "@/store/modules/common/constants";
import { Assessment, List, QuestionType } from "@/interfaces/app_assessments";

export default Vue.extend({
  name: "CreateScreeningTest",
  components: {
    GoBackHeader,
    AppOverlayLoader
  },
  data() {
    return {
      screening_questions: [
        {
          question: "",
          multiple_choice: false,
          options: ["", "", "", ""]
        }
      ] as ScreeningQuestionPayload[],
      generation_loading: false,
      generation_loading_msg: ""
    };
  },
  computed: {
    ...mapGetters("recruiter", {
      job_generation_prompt_resp: JOB_GENERATION_PROMPT_RESPONSE
    }),
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    }),
    ...mapGetters("common", {
      get_app_assessments: APP_ASSESSMENTS
    })
  },
  mounted() {
    if (!this.job_generation_prompt_resp) {
      this.$router.push({
        name: "recruiter-post-job"
      });
    }
  },
  methods: {
    ...mapMutations({
      root_error: ROOT_ERROR,
      root_notification: ROOT_NOTIFICATION
    }),
    ...mapMutations("recruiter", {
      set_ai_generated_job_post_prompt: JOB_GENERATION_FROM_PROMPT,
      set_ai_generated_prompt_resp: JOB_GENERATION_PROMPT_RESPONSE,
      set_ai_generated_matching_candidates: JOB_GENERATION_MATCHING_CANDIDATES,
      set_rejected_candidates: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
      set_shortlisted_candidates: JOB_GENERATION_REJECTED_MATCHING_CANDIDATES,
      set_all_candidates: CANDIDATE_DATA
    }),
    ...mapActions("recruiter", {
      generate_job_from_prompt: JOB_GENERATION_FROM_PROMPT,
      post_job: POST_JOB,
      activate_published_job: ACTIVATE_PUBLISHED_JOB,
      get_job_short_url: JOB_SHORT_URL,
      create_screening_questions: CREATE_SCREENING_QUESTION
    }),
    ...mapActions("common", {
      send_email: SEND_EMAIL
    }),
    add_question() {
      this.screening_questions.push({
        question: "",
        multiple_choice: false,
        options: ["", "", "", ""]
      });
    },
    allow_multiple_choice(index: number) {
      this.screening_questions[index].multiple_choice =
        !this.screening_questions[index].multiple_choice;
    },
    get_options(index: number) {
      return this.screening_questions[index].options;
    },
    add_option(index: number) {
      this.screening_questions[index].options.push("");
    },
    cancel_question(index: number) {
      this.screening_questions.splice(index, 1);
    },
    async post_job_and_add_questions() {
      try {
        this.generation_loading = true;
        this.generation_loading_msg = "Posting Job...";
        const job_post_payload = this.job_generation_prompt_resp;
        const job_post_form_data = new FormData();
        Object.entries(job_post_payload).forEach(([key, value]) => {
          job_post_form_data.append(key, value as string);
        });
        job_post_form_data.append("post_type", JobDataTypes.TEXT);

        const job_posted = await this.post_job(job_post_form_data);

        if (!job_posted) throw new Error("Failed to post job");

        let screening_assessment = {} as Assessment;
        if (this.get_app_assessments) {
          screening_assessment = this.get_app_assessments.find(
            (assessment: Assessment) => {
              return (
                assessment.assessment_type === List.JOB_SCREENING_QUESTIONS
              );
            }
          );
        }

        const jid = job_posted?.standardized_data?.jid;
        if (!jid) throw new Error("Failed to post job");

        this.set_ai_generated_prompt_resp({
          ...this.job_generation_prompt_resp,
          job_id: job_posted?.standardized_data?.jid
        });

        // Post Screening Questions to the assessment
        if (screening_assessment && screening_assessment.id) {
          const screening_questions: CreateScreeningQuestionsPayload = {
            assessment_id: screening_assessment.id, // Assessment Id
            questions: this.screening_questions.map(
              ({ question, multiple_choice, options }) => ({
                question_text: question,
                question_options: {
                  multiple_choice,
                  options: options.filter((option) => option && option.length)
                },
                question_type: QuestionType.TEXT,
                created_by: this.get_user_details.id,
                job_id: jid
              })
            ) as ScreeningQuestionsResponse[]
          };

          const screening_response = await this.create_screening_questions(
            screening_questions
          );

          if (!screening_response)
            throw new Error("Failed to create screening questions");
        }

        // const job_published = await this.activate_published_job(jid);
        // if (!job_published) throw new Error("Failed to post job");

        this.generation_loading_msg = "Fetching matching candidates...";
        const matching_candidates = await this.fetch_matching_candidates(jid);
        if (!matching_candidates)
          throw new Error("No matching candidates found");

        this.set_ai_generated_matching_candidates(matching_candidates);
        this.set_all_candidates(matching_candidates);
        this.root_notification("Job posted successfully");
        // Job url for public job
        const url = await this.generate_short_url(jid);

        // Send email to Internal Hr for Invite Job
        await this.send_email({
          user_ids: [this.get_user_details.id],
          type: EmailTypes.TWO_POINT_INTERNAL_JOB_POST,
          job: {
            jid: jid,
            title: job_posted?.standardized_data?.job_title,
            description: job_post_payload.job_description,
            link: url ?? `/recruiter/jobs/${jid}`
          }
        });

        // TODO: Navigate to next page
        await this.$router.push({
          name: "swipe-candidate-job-posting"
        });
      } catch (error: any) {
        this.root_error(error.message || "Internal server error");
      } finally {
        this.generation_loading = false;
        this.generation_loading_msg = "";
      }
    },
    async fetch_matching_candidates(jid: number) {
      try {
        const search_candidates = await get_search_candidates({
          job_ids: [jid]
        });
        const results = search_candidates?.data?.data?.results;
        if (results.length <= 0) {
          throw new Error("No matching candidates found");
        } else return results;
      } catch (e) {
        this.generation_loading = false;
        this.generation_loading_msg = "";
        return null;
      }
    },
    async generate_short_url(jobId: number) {
      const obj = {
        job_id: jobId,
        job_url: `https://${window.location.hostname}/public/job`
      };
      const response = await this.get_job_short_url(obj);
      return response.url ? response.url : undefined;
    }
  }
});
